import { useCallback } from 'react'
import { type SnackbarEnqueueFn, type SnackbarKey, type SnackbarOptions } from './types'
import { useSnackbarContext } from './use-snackbar-context'

/**
 * Be able to toasts messages to your view
 */
export const useSnackbar = (snackbarOptions?: SnackbarOptions) => {
  const { addToast, removeToast, dismissAll } = useSnackbarContext()

  const enqueueSnackbar: SnackbarEnqueueFn = useCallback(
    (message, options = snackbarOptions ?? {}) => addToast(message, options),
    [addToast, snackbarOptions]
  )

  const closeSnackbar = useCallback(
    (key: SnackbarKey) => (key ? removeToast(key) : dismissAll()),
    [removeToast, dismissAll]
  )

  return {
    enqueueSnackbar,
    closeSnackbar,
  }
}
